import { Dispatch, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { CustomerRoleFormFields } from "../Utils";
import { PoliciesCard } from "./PoliciesCard";
import { RoleDetailsCard } from "./RoleDetailsCard";
import { PoliciesAction, PolicyState } from "./RoleReducer";
import { UnsavedChangesPrompt } from "@velocity-ehs/component-library";
import { useHistory } from "react-router";
import { PolicySidebar } from "./PolicySidebar";

interface RoleFormProps {
  roleState: PolicyState;
  dispatch: Dispatch<PoliciesAction>;
  formMethods: UseFormReturn<CustomerRoleFormFields, unknown>;
  isLoading: boolean;
  updateRoleCallback: (
    data: CustomerRoleFormFields,
    policies: Array<{ id: string; name: string }>
  ) => void;
  readOnly?: boolean;
}

interface RolePermission {
  id: string;
  description: string;
  displayName: string;
}
export interface SelectedRolePolicy {
  name?: string;
  description?: string;
  permissions?: RolePermission[];
  scope?: {
    id: string;
    name: string;
    applications: Array<{ name: string }>;
  };
}

const RoleForm = ({
  formMethods,
  isLoading,
  readOnly,
  updateRoleCallback,
  roleState,
  dispatch,
}: RoleFormProps) => {
  const history = useHistory();

  const [showSideBar, setShowSidebar] = useState<boolean>(false);

  const [selectedPolicy, setSelectedPolicy] = useState({});
  const handleSelectedPolicy = (selectedPolicy: SelectedRolePolicy) => {
    setSelectedPolicy(selectedPolicy);
    setShowSidebar(true);
  };

  const handleCloseSlider = () => {
    setShowSidebar(false);
  };

  const onSubmit = async (data: { name: string; description: string }) => {
    updateRoleCallback(data, roleState.policies);
    dispatch({ type: "CLEAN" });
  };

  return (
    <form id="customer-role-form" onSubmit={formMethods.handleSubmit(onSubmit)}>
      <RoleDetailsCard
        formMethods={formMethods}
        isLoading={isLoading}
        readOnly={readOnly}
      />
      <PoliciesCard
        setRolePolicies={dispatch}
        roleState={roleState}
        handlePolicySelect={handleSelectedPolicy}
        readOnly={readOnly}
      />
      <UnsavedChangesPrompt
        isDirty={roleState.isDirty || formMethods.formState.isDirty}
        history={history}
      />
      <PolicySidebar
        visible={showSideBar}
        onHide={handleCloseSlider}
        selectedPolicy={selectedPolicy}
      />
    </form>
  );
};

export { RoleForm };
